<template>
    <div id="gci-station-language-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <h4 class=" text-2xl font-bold mb-6">Select Language</h4>
                    <div class="flex w-1/2">
                        <v-select v-model="selected_language" label="name" :options="languageOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false" :searchable="false" class="w-full mt-2"/>
                    </div>
                    <div class="flex align-center mt-12 pt-base justify-center">
                        <vs-button color="primary" type="filled" @click="updateLanguage" style="min-width: 150px;">Save</vs-button>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    name: 'gci-station-language',
    components: {
        'v-select': vSelect,
    },
    data(){
        return{
            languageOptions: [
                { name: 'English', value: 'en' },
                { name: 'Deutsch', value: 'de' },
                { name: 'French', value: 'fr' },
                { name: 'Spanish', value: 'sp' },
                { name: 'Italian', value: 'it' },
                { name: 'Dutch', value: 'nl' },
                { name: 'Danish', value: 'da' },
                { name: 'Swedish', value: 'sw' },
                { name: 'Portuguese', value: 'pt' },
                { name: 'Czech', value: 'cs' },
                { name: 'Finnish', value: 'fi' },
                { name: 'Irish', value: 'ir' },
                { name: 'Polish', value: 'pl' }
            ],
            selected_language: { name: 'English', value: 'en' },
            isOpenLoading: false,
            loaded_data_num: 0
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods:{
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: 'Update Language Failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        updateLanguage() {
            const obj = {
                key: 'config.checkin.language',
                value: this.selected_language ? this.selected_language.value : 'en'
            }
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text:'Update Language Success',
                    color:'success',
                    position:'top-right'})
            });
        }
    },
    created() {
        const obj = {
            key: 'config.checkin.language'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then((res) => {
            this.loaded_data_num++;
            let language_data = this.$store.getters["appSetting/keyStorage"];
            if(language_data) {
                for(let i = 0 ; i < this.languageOptions.length; i++) {
                    if(this.languageOptions[i].value == language_data.value) {
                        this.selected_language = this.languageOptions[i];
                        break;
                    }
                }
            }
        }).catch(() => {
            const obj = {
                key: 'config.checkin.language',
                value: 'en'
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>